import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import TrustBar from "@/components/TrustBar";
import About from "@/components/About";
import Services from "@/components/Services";
import Funding from "@/components/Funding";
import Projects from "@/components/Projects";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Helmet } from "react-helmet-async";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Maria Keutel – Beratung, Business-Coaching, Dozentin</title>
        <meta name="description" content="Beratung mit Klarheit, Struktur und Strategie. Business-Coaching, Fördermittel und Projekte – jetzt mehr erfahren." />
        <link rel="canonical" href="https://ma4consult.de/" />
        <meta property="og:title" content="Maria Keutel – Beratung, Business-Coaching, Dozentin" />
        <meta property="og:description" content="Beratung mit Klarheit, Struktur und Strategie. Business-Coaching, Fördermittel und Projekte aus Rosenheim." />
        <meta property="og:url" content="https://ma4consult.de/" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "MA4Consult – Maria Keutel",
            "description": "Beratung mit Klarheit, Struktur und Strategie. Business-Coaching, Fördermittelberatung und Finanzplanung für Gründer und Unternehmen.",
            "url": "https://ma4consult.de",
            "telephone": "+491733159421",
            "email": "mk@ma4consult.de",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Gießereistraße 29",
              "addressLocality": "Rosenheim",
              "postalCode": "83022",
              "addressCountry": "DE"
            },
            "makesOffer": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Business-Coaching" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fördermittelberatung" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Finanzplanung & Controlling" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "INQA-Coaching" } }
            ]
          })}
        </script>
      </Helmet>
      <Navigation />
      <Hero />
      <Stats />
      <TrustBar />
      {/* Wave divider: Stats → About */}
      <div className="wave-divider wave-divider-primary-to-subtle" />
      <About />
      <Services />
      {/* Wave divider: Services → Funding */}
      <div className="wave-divider wave-divider-white-to-subtle" />
      <Funding />
      <Projects />
      {/* Wave divider: Projects → Testimonials */}
      <div className="wave-divider wave-divider-subtle-to-white" />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
